module.exports = __webpack_public_path__ + "img/greyAdd.6994aa84.svg";